export const termsAndConditions = {
  title: "Términos y condiciones",
  subtitle:
    "Personaliza los términos y condiciones que verán tus clientes en la tienda.",
  answerLabel: "Respuesta",
  clearAnswer: "Limpiar respuesta",
  hideTitle: "Ocultar términos y condiciones",
  hideWarning:
    "Si ocultas esta sección, tus clientes no verán los términos y condiciones en tu tienda.",
  preview: "Vista previa",
  save: "Guardar",
  saving: "Guardando...",
  saveSuccess: "Términos y condiciones actualizados correctamente",
  saveError: "No se pudieron guardar los términos y condiciones",
};
